<template>
  <grid  grid-id="details-network-grid"  :no-records= "'No associated records found'" :fields="fields" :items="details.network" />
</template>

<script>
//import gridFields from '../../../../../fields';

import Grid from '@/shared/components/Grid';
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';

export default {
  components: {
    Grid,
  },
  props:['companyId'],
  data() {
    return {
      fields: [
        { key: 'commands', label: '', tdClass: 'grid-commands-width-1' },
        { key: 'name', label: 'Company', sortable: true },
        { key: 'channel', label: 'Channel', sortable: true },
        { key: 'primaryContact', label: 'Contact', sortable: true },
        { key: 'sharedCases', label: '# of Shared Cases', sortable: true },
        { key: 'networkCaseRoles', label: 'Network Case Roles', sortable: true },
      ],
    }
  },
   computed : {
      ...mapState('companies', [
      "details"
    ]),
  },
    methods : {
     ...mapActions('companies', [ 
      'getNetworksDetails'
    ]),
     async getNetworksDetailsData() {
      await this.getNetworksDetails(this.companyId);
    },
  },
  created(){
      this.getNetworksDetailsData();
  }
}
</script>